document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".tab-button");
  const productCards = document.querySelectorAll(".card-product-collection");
  let isAnimating = false;

  // Función para cambiar de pestaña con animaciones suaves
  function switchTab(tabName) {
    if (isAnimating) return; // Prevent multiple animations
    isAnimating = true;

    // Actualizar botones activos
    tabButtons.forEach((button) => {
      if (button.dataset.tab === tabName) {
        button.classList.add("active");
      } else {
        button.classList.remove("active");
      }
    });

    // Fade out all cards first
    productCards.forEach((card) => {
      /** @type {HTMLElement} */ (card).style.opacity = '0';
      /** @type {HTMLElement} */ (card).style.transform = 'translateY(10px)';
    });

    // After fade out, update visibility and fade in relevant cards
    setTimeout(() => {
      productCards.forEach((card) => {
        if (tabName === "all" || card.dataset.type === tabName) {
          /** @type {HTMLElement} */ (card).style.display = "block";
          // Trigger reflow
          /** @type {HTMLElement} */ (card).offsetHeight;
          // Fade in with stagger effect
          setTimeout(() => {
            /** @type {HTMLElement} */ (card).style.opacity = '1';
            /** @type {HTMLElement} */ (card).style.transform = 'translateY(0)';
          }, 50);
        } else {
          /** @type {HTMLElement} */ (card).style.display = "none";
        }
      });
      
      // Reset animation lock after all animations complete
      setTimeout(() => {
        isAnimating = false;
      }, 300);
    }, 200);
  }

  // Añadir event listeners a los botones
  tabButtons.forEach((button) => {
    button.addEventListener("click", function () {
      switchTab(this.dataset.tab);
    });
  });

  // Inicializar con la primera pestaña activa
  if (tabButtons.length > 0) {
    switchTab(tabButtons[0].dataset.tab);
  }
});
